import { Expose } from 'class-transformer';
import { ElementOptions } from './element-options';
export class SurveyRatingElementOptions extends ElementOptions {
  @Expose()
  rating!: number;
}
